export interface BlueprintStepColors {
  pillColor: string
  pillTextColor: string
}

const STEP_COLORS: Record<number, BlueprintStepColors> = {
  0: {
    pillColor: 'linear-gradient(90.25deg, #DEDEDE -32.03%, #F7F7F7 18.7%, #FFFFFF 108.36%)',
    pillTextColor: '#111',
  },
  1: { pillColor: 'linear-gradient(90deg, #5521FF 0%, #331499 100%)', pillTextColor: '#fff' },
  2: { pillColor: 'linear-gradient(90deg, #C7FF6E 0%, #EDFFD1 100%)', pillTextColor: '#111' },
  3: { pillColor: 'linear-gradient(90deg, #000000 0%, #666666 100%)', pillTextColor: '#fff' },
  4: { pillColor: 'linear-gradient(90deg, #838383 0%, #DCDCDC 100%)', pillTextColor: '#111' },
  5: { pillColor: 'linear-gradient(90deg, #5521FF 0%, #34149C 100%)', pillTextColor: '#fff' },
  6: { pillColor: 'linear-gradient(90deg, #C7FF6E 0%, #EDFFD1 100%)', pillTextColor: '#111' },
  7: { pillColor: 'linear-gradient(90deg, #3D3D3D 0%, #5A5A5A 100%)', pillTextColor: '#fff' },
}

const DEFAULT_COLORS: BlueprintStepColors = { pillColor: '#CFCFCF', pillTextColor: '#111' }

/**
 * Get color metadata for a blueprint step by its step number.
 * Icons are added on top of this in the dashboard's blueprint-steps.ts.
 */
export function getStepColors(stepNumber: number): BlueprintStepColors {
  return STEP_COLORS[stepNumber] || DEFAULT_COLORS
}

export function getStepNumbers(): number[] {
  return Object.keys(STEP_COLORS)
    .map(Number)
    .sort((a, b) => a - b)
}
